/**
 * 3.1.3.1 블랙 리스트 등록 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import { pcDownloadFile } from '~/utils/files'

const initSearchBlistList = () => {
  return {
    blist_desc: '',
    blist_dst_ip_list: '',
    blist_dst_port_list: '',
    blist_ip_ver_type: null, // [$ blist_deny_type 과 둘 중 1개만 가능], (Define=1,2) 블랙리스트 아이피 버전 유형
    blist_prtc_list: '',
    blist_src_ip_list: '',
    blist_src_port_list: '',
    page_cnt: 30,
    page_pos: 0,
    blist_src_port_any_yn: 1,
    blist_dst_port_any_yn: 1,
    blist_src_ip_any_yn: 1,
    blist_dst_ip_any_yn: 1,
    device_id: null,
    blist_prf_id: null, // 장비별 블랙리스트 Tab Null 고정
    blist_deny_type: -1 // [$ blist_ip_ver_type 과 둘 중 1개만 가능], (Define=None,0,1,2,3,4) 차단방식 0:출발지 주소 차단, 1 : 목적지 주소 차단, 2: 출발지 & 목적지 주소 차단, 3: 출발지 & 목적지 포트 차단, 4: 목적지 주소 & 포트 차단, NULL 차단방식 없음
  }
}

export const state = () => ({
  // api url 목록
  apiUrl: {
    blackListRegUrl: '/api/cm/blist',
    blackListSave: '/api/cm/blist/save'
  },
  protocolUrl: '/api/cm/objects/prtc',
  blackListTotalCount: 0,
  blackListRegList: [],
  blackListRegListFilter: [],
  blackListRegResult: null,
  expireBlackListRegResult: null,
  errorMessage: null,
  searchBlistList: initSearchBlistList(),
  protocolOption: []
})

export const mutations = {
  // 블랙리스트 조회
  // mutBlackListReg (state, payload) {
  //   state.blackListRegList = payload
  // },
  setTotalCount (state, data) {
    state.blackListTotalCount = data
  },
  initSearchParam (state) {
    state.searchBlistList = initSearchBlistList()
  },
  mutBlackListReg (state, payload) {
    state.blackListRegList = payload.filter(item => {
      item.blist_prtc_name = (item.blist_prtc === null) ? 'ANY' : _.find(state.protocolOption, ['value', item.blist_prtc]).label
      return item
    })
    state.blackListRegListFilter = state.blackListRegList
  },
  mutBlackListRegFilter (state, payload) {
    state.blackListRegListFilter = state.blackListRegList.filter((item) => {
      return Object.keys(item).filter(vkey => { return item[vkey].indexOf(payload) >= 0 }).length > 0
    })
  },
  // 블랙리스트 추가
  mutPostBlackListReg (state, payload) {
    state.blackListRegResult = payload
  },
  // 블랙리스트 삭제
  mutDelBlackListReg (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.blackListRegResult.splice(itemIndex, 1)
    }
  },
  // 만료된 블랙리스트 전체 삭제
  mutDelExpireBlackListReg (state, payload) {
    state.expireBlackListRegResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  getProtocolData (state, data) {
    state.protocolOption = [{label: 'ANY', value: -1}]
    // state.protocolOption = []
    for (const item of data.result) {
      state.protocolOption.push({
        label: item.prtc_obj_uname,
        value: item.prtc_obj_prtc
      })
    }
  }
}

export const actions = {
  async applyAction () {
    const result = await this.$axios.$put(`/api/cm/blist/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelAction () {
    const result = await this.$axios.$put(`/api/cm/blist/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 블랙리스트 조회
  async acsBlackListReg ({commit, state}) {
    const resultParam = {}
    const param = _.cloneDeep(state.searchBlistList)
    resultParam.blist_ip_ver_type = (param.blist_ip_ver_type === 0) ? null : param.blist_ip_ver_type // (Define=1,2) 블랙리스트 아이피 버전 유형
    resultParam.blist_prtc_list = (param.blist_prtc_list === '') ? null : param.blist_prtc_list // 블랙리스트 프로토콜
    resultParam.blist_src_port_list = (param.blist_src_port_list === '') ? null : param.blist_src_port_list // 블랙리스트 출발지 포트
    resultParam.blist_dst_port_list = (param.blist_dst_port_list === '') ? null : param.blist_dst_port_list //  블랙리스트 목적지 포트
    resultParam.blist_src_ip_list = (param.blist_src_ip_list === '') ? null : param.blist_src_ip_list // 블랙리스트 출발지 아이피
    resultParam.blist_dst_ip_list = (param.blist_dst_ip_list === '') ? null : param.blist_dst_ip_list // 블랙리스트 목적지 아이피
    resultParam.blist_desc = (param.blist_desc === '') ? null : param.blist_desc // 블랙리스트 설명
    resultParam.blist_src_port_any_yn = param.blist_src_port_any_yn // (Define=0,1) 출발지 포트 ANY 포함 여부
    resultParam.blist_dst_port_any_yn = param.blist_dst_port_any_yn // (Define=0,1) 목적지 포트 ANY 포함 여부
    resultParam.blist_src_ip_any_yn = param.blist_src_ip_any_yn // (Define=0,1) 출발지 주소 ANY 포함 여부
    resultParam.blist_dst_ip_any_yn = param.blist_dst_ip_any_yn // (Define=0,1) 목적지 주소 ANY 포함 여부
    resultParam.page_cnt = param.page_cnt
    resultParam.page_pos = param.page_pos
    resultParam.device_id = param.device_id
    resultParam.blist_prf_id = null // 프로파일 ID NULL 전체 -> ** 프로파일 null 고정
    resultParam.blist_deny_type = (param.blist_deny_type === -1) ? 0 : param.blist_deny_type // (Define=None,0,1,2,3,4) 차단방식 0:출발지 주소 차단, 1 : 목적지 주소 차단, 2: 출발지 & 목적지 주소 차단, 3: 출발지 & 목적지 포트 차단, 4: 목적지 주소 & 포트 차단, NULL 차단방식 없음
    // blist_deny_type 0 에서 전체 조회시 사용할 값 확인 후 변경 필요.

    try {
      const data = await this.$axios.$put(`${state.apiUrl.blackListRegUrl}`, resultParam, {loading: true, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutBlackListReg', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getTotalTotalCount ({commit, state}) {
    const resultParam = {}
    const param = _.cloneDeep(state.searchBlistList)
    resultParam.blist_ip_ver_type = (param.blist_ip_ver_type === 0) ? null : param.blist_ip_ver_type // (Define=1,2) 블랙리스트 아이피 버전 유형
    resultParam.blist_prtc_list = (param.blist_prtc_list === '') ? null : param.blist_prtc_list // 블랙리스트 프로토콜
    resultParam.blist_src_port_list = (param.blist_src_port_list === '') ? null : param.blist_src_port_list // 블랙리스트 출발지 포트
    resultParam.blist_dst_port_list = (param.blist_dst_port_list === '') ? null : param.blist_dst_port_list //  블랙리스트 목적지 포트
    resultParam.blist_src_ip_list = (param.blist_src_ip_list === '') ? null : param.blist_src_ip_list // 블랙리스트 출발지 아이피
    resultParam.blist_dst_ip_list = (param.blist_dst_ip_list === '') ? null : param.blist_dst_ip_list // 블랙리스트 목적지 아이피
    resultParam.blist_desc = (param.blist_desc === '') ? null : param.blist_desc // 블랙리스트 설명
    resultParam.blist_src_port_any_yn = param.blist_src_port_any_yn // (Define=0,1) 출발지 포트 ANY 포함 여부
    resultParam.blist_dst_port_any_yn = param.blist_dst_port_any_yn // (Define=0,1) 목적지 포트 ANY 포함 여부
    resultParam.blist_src_ip_any_yn = param.blist_src_ip_any_yn // (Define=0,1) 출발지 주소 ANY 포함 여부
    resultParam.blist_dst_ip_any_yn = param.blist_dst_ip_any_yn // (Define=0,1) 목적지 주소 ANY 포함 여부
    resultParam.device_id = param.device_id
    resultParam.blist_prf_id = null // 프로파일 ID NULL 전체 -> ** 프로파일 null 고정
    resultParam.blist_deny_type = (param.blist_deny_type === -1) ? 0 : param.blist_deny_type // (Define=None,0,1,2,3,4) 차단방식 0:출발지 주소 차단, 1 : 목적지 주소 차단, 2: 출발지 & 목적지 주소 차단, 3: 출발지 & 목적지 포트 차단, 4: 목적지 주소 & 포트 차단, NULL 차단방식 없음
    // blist_deny_type 0 에서 전체 조회시 사용할 값 확인 후 변경 필요.

    try {
      const data = await this.$axios.$put(`${state.apiUrl.blackListRegUrl}/cnt`, resultParam, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('setTotalCount', data.result[0].msg)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 블랙리스트 추가
  async acsPostBlackListReg ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.blackListRegUrl}`, payload)
      if (data.code !== 'ok') {
        return {code: data.code, errors: data.result.msg}
      } else {
        return {code: 'ok'}
      }
      // commit('mutPostBlackListReg', data)
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 블랙리스트 삭제
  async acsDelBlackListReg ({commit, state}, param) {
    let isMulty = false
    if (param.idList.blist_id_list.length > 1) {
      isMulty = true
    }
    try {
      const data = await this.$axios.$put(`${state.apiUrl.blackListRegUrl}/multi`, param.idList, {successAlert: false})
      if (data.code !== 'ok') {
        if (isMulty) {
          return {code: 'pok', errors: data.result.msg}
        }
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 만료된 블랙리스트 전체 삭제
  async acsDelExpireBlackListReg ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.blackListRegUrl}`, payload)
      // commit('mutDelBlackListReg', res)
      if (res.code === 'ok') {
        return 'ok'
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 블랙리스트 저장
  async saveBlackListReg ({commit, state}) {
    const result = {}

    try {
      const resultParam = state.searchBlistList
      const {data, fileName} = await this.$axios.$file(`${state.apiUrl.blackListSave}`, resultParam, {responseType: 'blob', successAlert: false})
      pcDownloadFile(data, fileName)

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return []
    }
  },
  async getProtocolData ({commit, state}) { // 프로토콜 목록
    try {
      const id = 0
      const data = await this.$axios.$get(`${state.protocolUrl}/${id}`, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getProtocolData', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}
export const strict = false
